._input_19l9q_1 {
  margin: 0 px(-12);
  width: calc(100% + px(24));
  font-variant-numeric: tabular-nums;
}